import * as patronUtils from '@tock/shared/utils/patron';
import { CheckoutProps } from 'routes/business/CheckoutRouteEnhanced';
import { FlowRouteProps } from 'components/render-prop-components/FlowRoute';
import { parseUrl } from './domainUtils';

export function shouldShowCompleteProfile<T = CheckoutProps>({ app }: FlowRouteProps<T>): boolean {
  const { patron, jwtToken } = app;
  if (!jwtToken) {
    return false;
  }
  return !patronUtils.hasCompleteProfile(patron);
}

export function isSourceTockWidget(search: string): boolean {
  const { query: searchQuery } = parseUrl(search);
  const tockSource = searchQuery?.['tock_source'];
  return (
    tockSource !== undefined &&
    tockSource.length > 0 &&
    (tockSource === 'tock_widget' || tockSource.includes('Squarespace'))
  );
}
